import { Building2 } from 'lucide-react';
import { Skeleton } from '@/common/components/ui/skeleton';
import { DialogHeader, DialogTitle, DialogDescription } from '@/common/components/ui/dialog';
import { Trans } from '@lingui/react/macro';

export function AddOrgDialogSkeleton() {
  return (
    <>
      <DialogHeader>
        <div className="flex items-center gap-3 mb-1">
          <div className="flex size-10 items-center justify-center rounded-xl bg-primary/10">
            <Building2 size={20} className="text-primary" />
          </div>
          <div>
            <DialogTitle>
              <Trans>Add organization</Trans>
            </DialogTitle>
            <DialogDescription>
              <Trans>Grants all members of the organization access to this supply point.</Trans>
            </DialogDescription>
          </div>
        </div>
      </DialogHeader>

      <div className="space-y-4">
        {/* Search input skeleton */}
        <Skeleton className="h-9 w-full" />

        {/* Org list skeletons */}
        <div className="space-y-1">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center gap-3 px-3 py-2.5">
              <Skeleton className="size-8 rounded-lg shrink-0" />
              <div className="flex-1 space-y-1.5">
                <Skeleton className="h-3.5 w-40" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
          ))}
        </div>

        {/* Action buttons skeleton */}
        <div className="flex justify-end gap-3 pt-1">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-9 w-36" />
        </div>
      </div>
    </>
  );
}
